import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Seccion from "../../Seccion";

function ArticulosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [pesoCaja, setPesoCaja] = useState(0);
  const [tamanoCaja, setTamanoCaja] = useState("NA");
  const [piezasPorCaja, setPiezasPorCaja] = useState(0);
  const [costoUSD, setCostoUSD] = useState(0);
  const [costoMX, setCostoMX] = useState(0);
  const [venta, setVenta] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [anada, setAnada] = useState("NV");
  const [presentacionMl, setPresentacionMl] = useState(750);
  const [graduacion, setGraduacion] = useState(0);
  const [certificacion, setCertificacion] = useState("");
  const [mevushal, setMevushal] = useState("No");
  const [kosherPesaj, setKosherPesaj] = useState("No");
  const [notasCata, setNotasCata] = useState("NA");
  const [maridaje, setMaridaje] = useState("NA");
  const [tempServicio, setTempServicio] = useState("NA");
  const [tasaIEPS, setTasaIEPS] = useState(26.5);
  const [EAN, setEAN] = useState("NA");
  const [vendedores, setVendedores] = useState("Si");
  const [visibleInventario, setVisibleInventario] = useState("Si");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  const utilidad = (parseFloat(venta || 0) - parseFloat(costoMX || 0));
const porcentajeUtilidad = venta > 0
  ? (utilidad / venta) * 100
  : 0;

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
        if (allEmpresas[0]) setSelectedEmpresa(allEmpresas[0]._id);
      })
      .catch((err) => {
        console.log(err);
      })
    axios
    .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    try {
      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            nombre,
            descripcion: nombre,
            pesoCaja,
            tamanoCaja,
            piezasPorCaja,
            costoUSD,
            costoMX,
            venta,
            observaciones,
            codigoSAT,
            codigoUnidad,
            lineas: selectedLinea,
            familias: selectedFamilia,
            ...(selectedColeccion && selectedColeccion !== "0" ? { colecciones: selectedColeccion } : {}),
            proveedores: selectedProveedor,
            ano: anada,
            anada,
            presentacionMl,
            graduacion,
            certificacion,
            mevushal,
            kosherPesaj,
            notasCata,
            maridaje,
            tempServicio,
            tasaIEPS,
            EAN,
            vendedores,
            visibleInventario,
            empresas: selectedEmpresa,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          axios
            .post(
              URL_INVENTARIOS,
              {
                articulos: data.data._id,
                areas: AREAS_CEDIS,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear vino",
                  detalle: `${nombre} ${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Listo", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Algo salio mal",
                text: "No se pudo completar",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Algo salio mal",
            text: "No se pudo completar",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal",
        text: "No se pudo completar",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">Nuevo Vino</h3>
          <Form onSubmit={saveArticulos}>
            <Seccion titulo="Datos del vino" icono="fas fa-wine-bottle">
              <Row>
                <Col md={3}>
                <Label>Codigo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Tipo de vino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedLinea}
                  required
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Tipo de vino</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Región</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedFamilia}
                  required
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Región</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Varietal</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Varietal</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
                <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </Col>
              </Row>
            </Seccion>
            <Seccion titulo="Ficha kosher" icono="fas fa-star-of-david">
              <Row>
                <Col md={3}>
                <Label>Añada</Label>
                <Input
                  type="text"
                  placeholder="2021 o NV"
                  value={anada}
                  required
                  onChange={(e) => {
                    setAnada(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Presentación (ml)</Label>
                <Input
                  type="number"
                  min="0"
                  value={presentacionMl}
                  required
                  onChange={(e) => {
                    setPresentacionMl(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Graduación (% Alc.)</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={graduacion}
                  onChange={(e) => {
                    setGraduacion(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Certificación (Hechsher)</Label>
                <Input
                  type="text"
                  placeholder="OU, OK, Star-K..."
                  value={certificacion}
                  onChange={(e) => {
                    setCertificacion(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Mevushal</Label>
                <Input
                  type="select"
                  value={mevushal}
                  onChange={(e) => {
                    setMevushal(e.target.value);
                  }}
                >
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>
                <Col md={3}>
                <Label>Kosher para Pésaj</Label>
                <Input
                  type="select"
                  value={kosherPesaj}
                  onChange={(e) => {
                    setKosherPesaj(e.target.value);
                  }}
                >
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>
              </Row>
            </Seccion>
            <Seccion titulo="Precios e impuestos" icono="fas fa-tags">
              <Row>
                <Col md={3}>
                <Label>Botellas por Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Botellas por Caja"
                  value={piezasPorCaja}
                  required
                  onChange={(e) => {
                    setPiezasPorCaja(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Costo USD</Label>
                <Input
                  type="text"
                  placeholder="Costo USD"
                  value={costoUSD}
                  required
                  onChange={(e) => {
                    setCostoUSD(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="text"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
                <Label>Venta</Label>
                <Input
                  type="text"
                  placeholder="Venta"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col>
                <Col md={3}>
  <Label>Utilidad</Label>
  <Input
    type="text"
    value={`$ ${utilidad.toFixed(2)}`}
    disabled
  />
</Col>
                <Col md={3}>
  <Label>% Utilidad</Label>
  <Input
    type="text"
    value={`${porcentajeUtilidad.toFixed(2)} %`}
    disabled
  />
</Col>
                <Col md={3}>
                <Label>Tasa IEPS</Label>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  step="any"
                  list="tasasIEPS"
                  value={tasaIEPS}
                  required
                  onChange={(e) => setTasaIEPS(e.target.value)}
                />
                <datalist id="tasasIEPS">
                  <option value="26.5" />
                  <option value="30" />
                  <option value="53" />
                </datalist>
              </Col>
              </Row>
            </Seccion>
            <div className="form-acciones">
              {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoArticulos"
              className="btn btn-secondary"
            >
              Regresar
            </Button>
            </div>
          </Form>
          <br />

        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreate;
